export default class CheckoutEnterDeliveryUpdatesEmailCheckBox {
	constructor() {
		const checkbox = document.getElementById('deliveryUpdatesOptIn');

		if (checkbox) {
			const eventHandler = ({ target }) => {
				this.setEmailInputDisabledState('deliveryUpdatesEmail', target.checked);
				this.setEmailInputValue('deliveryUpdatesEmail', target.checked);
			};
			checkbox.addEventListener('change', eventHandler, false);
		}
	}

	setEmailInputDisabledState(blockElement, isEnterDeliveryUpdatesEmailEnabled) {
		const emailInput = document.getElementById(blockElement);
		emailInput.disabled = !isEnterDeliveryUpdatesEmailEnabled;
	}

	setEmailInputValue(blockElement, isEnterDeliveryUpdatesEmailEnabled) {
		const emailInput = document.getElementById(blockElement);
		if (!isEnterDeliveryUpdatesEmailEnabled) {
			emailInput.value = '';
		}
	}
}
